import { isNil } from '@semios/app-platform-common'
import { translate } from 'i18n/i18n'

export const formatValue = (value: number | null | undefined): string => {
  if (isNil(value)) return translate.phrases.templates('-')

  return String(value)
}
